<template>
  <div class="text-center">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <v-btn
            color="primary"
            icon
            @click="dialog = true"
          >
            <v-icon>
              mdi-account-group
            </v-icon>
          </v-btn>
        </div>
      </template>
        <span>Administrar responsables administrativos del servicio</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog"
      width="1000"
      max-width="1000"
      scrollable
    >
      <v-card>
        <v-card-title class="text-h5 blue darken-4 lighten-2">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="h5" style="color:white!important;">Responsables Administrativos</div>
            </v-col>
            <v-col cols="12">
              <div class="subtitle-1" style="color:white!important;">{{objServicio.nombreServicio}}</div>          
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row class="mx-2 mt-2">
            <v-col cols="12">
              <form-servicio-responsable :obj-servicio="objServicio" :flag-init="flagInitForm" :id-accion="idAccionForm" :obj-responsable="objResponsable" :fn-on-save="fnAddFlagTable" :fn-set-id-accion="setIdAccion"></form-servicio-responsable>
            </v-col>
          </v-row>

          <v-row class="mx-2 mt-2">
            <v-col cols="12">
              <data-table-servicio-responsables :obj-servicio="objServicio" :flag-reload="flagReloadTable" :fn-set-edit-responsable="setEditResponsable"></data-table-servicio-responsables>
            </v-col>
          </v-row>
        </v-card-text>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>

      <v-snackbar
        key="snackbar_dialogresponsables2"
        v-model="snackbar2"
        :bottom="true"
        :multi-line="true"
        :color="snackbarColor2"
      >
        <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
        {{ snackbarTexto2 }}
        <v-btn 
            dark 
            text 
            @click="snackbar2 = false">
            Cerrar
        </v-btn>
      </v-snackbar>
    </v-dialog>

    <v-dialog v-model="dialogConfirmar" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Está seguro?</v-card-title>
        <v-card-text>Se perderán los cambios que no hayan sido guardados. ¿Desea continuar?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="dialogConfirmar = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="dialogConfirmar = false; dialog = false;">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      key="snackbar_dialogresponsables"
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :color="snackbarColor"
    >
      {{ snackbarTexto }}
      <v-btn dark text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
    
  </div>
</template>

<script>
export default {
  name: "DialogResponsables",
  components: {
    FormServicioResponsable: () =>
      import("../bandejaServicios/FormServicioResponsable"),
    DataTableServicioResponsables: () =>
      import("../bandejaServicios/DataTableServicioResponsables"),
  },
  props: {
    objServicio: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      dialogConfirmar: false,
      loading: true,
      disabledNew: false,
      flagReloadTable: 1,

      flagInitForm: 1,
      idAccionForm: 1,
      objResponsable: {
        idCatServicio: 0,
        nue: '',
        nombre: '',
        correo: '',
        esTitular: false,
        habilitado: false
      },


      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",

      snackbar2: false,
      snackbarTexto2: "",
      snackbarColor2: "",
    };
  },
  computed: {
  },
  watch:{
    dialog: {
      handler(newValue, oldValue) {
        if(newValue == true){
          this.flagReloadTable++;
        }
      },
    },
  },
  beforeMount(){
  },
  mounted() {
    this.objResponsable.idCatServicio = this.objServicio.idCatServicio;
  },
  methods: {
    fnAddFlagTable(){
      this.flagReloadTable++;
    },
    setEditResponsable(objRespEdit){
      this.idAccionForm = 2;
      this.objResponsable = objRespEdit;
      this.flagInitForm++;
    },
    setIdAccion(_idAccion){
      this.idAccionForm = _idAccion;
    }
    /* fnCerrarDialog(){
      if(this.idsFormulasEdit.length == 0){
        this.dialog = false;
      }
      else{
        this.dialogConfirmar = true;
      }
    } */
  },  
};
</script>